import { css } from 'styled-components';
import { P as PADDING_OPTIONS } from '../../../types/PaddingOptions-CB0CIxyr.js';

// Create gap mixin factory
const createGapMixin = platform => css(["", ""], ({
  $gap,
  $rowGap,
  $columnGap,
  theme
}) => {
  const rules = [];

  // Helper function to validate padding value
  // eslint-disable-next-line max-len
  const isValidPaddingValue = value => {
    var _theme$spacing;
    return PADDING_OPTIONS.includes(value) && !!((_theme$spacing = theme.spacing[value]) !== null && _theme$spacing !== void 0 && _theme$spacing[platform]);
  };

  // Handle gap prop first
  if ($gap) {
    const splitGap = $gap.trim().split(' ');
    if (splitGap.length === 1) {
      // Single value: applies to both row and column gap
      if (!$rowGap && isValidPaddingValue(splitGap[0])) {
        rules.push(`row-gap: ${theme.spacing[splitGap[0]][platform]};`);
      }
      if (!$columnGap && isValidPaddingValue(splitGap[0])) {
        rules.push(`column-gap: ${theme.spacing[splitGap[0]][platform]};`);
      }
    } else {
      // Two values: first is row-gap, second is column-gap
      if (!$rowGap && isValidPaddingValue(splitGap[0])) {
        rules.push(`row-gap: ${theme.spacing[splitGap[0]][platform]};`);
      }
      if (!$columnGap && isValidPaddingValue(splitGap[1])) {
        rules.push(`column-gap: ${theme.spacing[splitGap[1]][platform]};`);
      }
    }
  }

  // Individual props override gap prop
  if ($rowGap && isValidPaddingValue($rowGap)) {
    rules.push(`row-gap: ${theme.spacing[$rowGap][platform]};`);
  }
  if ($columnGap && isValidPaddingValue($columnGap)) {
    rules.push(`column-gap: ${theme.spacing[$columnGap][platform]};`);
  }
  return rules.join('\n');
});
const gapMixin = createGapMixin('default');
const mobileGapMixin = createGapMixin('mobile');

export { gapMixin as g, mobileGapMixin as m };
//# sourceMappingURL=index-CO-zSMJ0.js.map
